// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import { DataTableBody } from "@insite/mobius/index";
import { CustomerPoNumber } from "@store/Framework/Services/CustomerPoNumberService";
import BuyingListTableHead from "@store/Library/Components/BuyingList/BuyingListTableHead";
import { StyledCol } from "@store/Library/Components/Common/StyledCol";
import ManageDefaultPOEditingRow from "@store/Library/Widgets/ManageDefaultPO/ManageDefaultPOEditingRow";
import ManageDefaultPOTableRow from "@store/Library/Widgets/ManageDefaultPO/ManageDefaultPOTableRow";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React from "react";
import { css } from "styled-components";

interface ManageDefaultPOTableStyles {
    dataTable?: DataTableProps;
}
const tableHeaders = [translate("PO Number"), translate("Start Date"), translate("End Date"), translate("Actions")];
const tableWidths = [35, 25, 25, 15];
const manageDefaultPOTableStyles: ManageDefaultPOTableStyles = {
    dataTable: {
        css: css`
            th:last-child {
                text-align: center;
            }
            table-layout: fixed;
            width: 100%;
        `,
    },
};

interface ManageDefaultPoTableProps {
    onSave: (customerPoNumber: CustomerPoNumber | null) => void;
    isNew: boolean;
    customerPOs: CustomerPoNumber[];
    editingPo?: CustomerPoNumber;
    setEditingPo: (customerPoNumber: CustomerPoNumber) => void;
    validateEndDate: (startDate: Date, endDate: Date | null) => boolean;
    validateStartDate: (startDate: Date, endDate: Date | null) => boolean;
    extendedStyles?: ManageDefaultPOTableStyles;
    overrideStyles?: ManageDefaultPOTableStyles;
    onDelete: (poId: string) => void;
    activePoId?: string;
}
const ManageDefaultPOTable: React.FC<ManageDefaultPoTableProps> = ({
    onSave,
    onDelete,
    isNew,
    setEditingPo,
    activePoId,
    editingPo,
    customerPOs,
    validateEndDate,
    validateStartDate,
    extendedStyles,
    overrideStyles,
}) => {
    const styles = useExpandProps(manageDefaultPOTableStyles, extendedStyles, overrideStyles);
    return (
        <DataTable data-test-selector="PoOverride_poTable" {...styles.dataTable}>
            <colgroup>
                {tableWidths.map((width, index) => (
                    <StyledCol width={width} key={index.toString()} />
                ))}
            </colgroup>
            <BuyingListTableHead buyingListHeaders={tableHeaders} />
            <DataTableBody>
                {customerPOs.map(customerPoNumber => {
                    const isActiveEditingPo = editingPo?.id === customerPoNumber.id;
                    return isActiveEditingPo ? (
                        <ManageDefaultPOEditingRow
                            onSave={onSave}
                            isNew={isNew}
                            onCancel={() => onSave(null)}
                            key={customerPoNumber.id}
                            customerPoNumber={customerPoNumber}
                            validateEndDate={validateEndDate}
                            validateStartDate={validateStartDate}
                        />
                    ) : (
                        <ManageDefaultPOTableRow
                            isActive={activePoId === customerPoNumber.id}
                            onDelete={onDelete}
                            isEditing={!!editingPo}
                            key={customerPoNumber.id}
                            customerPoNumber={customerPoNumber}
                            setEditingPo={setEditingPo}
                        />
                    );
                })}
            </DataTableBody>
        </DataTable>
    );
};

export default ManageDefaultPOTable;
